import { useEffect, useState } from "react";
import { logtoClient } from "../lib/logto-client";

export const POST_REDIRECT_KEY = "logto:post-redirect-uri";

type CallbackExecutionState = {
  callbackUrl: string | null;
  exchangePromise: Promise<void> | null;
};

export function Callback() {
  const [error, setError] = useState<string | null>(null);
  const [executionState] = useState<CallbackExecutionState>({
    callbackUrl: null,
    exchangePromise: null,
  });

  useEffect(() => {
    const callbackUrl = window.location.href;
    if (executionState.callbackUrl === callbackUrl && executionState.exchangePromise !== null) {
      return;
    }

    executionState.callbackUrl = callbackUrl;
    const handleCallback = async () => {
      try {
        await logtoClient.handleSignInCallback(callbackUrl);
        const postRedirectUri = sessionStorage.getItem(POST_REDIRECT_KEY) ?? "/";
        sessionStorage.removeItem(POST_REDIRECT_KEY);
        window.location.href = postRedirectUri;
      } catch (err: unknown) {
        const errorName = err instanceof Error ? err.name : "UnknownError";
        console.error("[Auth] Sign-in callback failed:", new Error(errorName));
        setError("Sign-in failed. Redirecting...");
        setTimeout(() => {
          window.location.href = "/?auth_error=true";
        }, 1500);
      }
    };
    executionState.exchangePromise = handleCallback();
  }, [executionState]);

  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="text-center">
        {error ? (
          <p className="text-red-500">{error}</p>
        ) : (
          <>
            <div className="mx-auto mb-4 h-8 w-8 animate-spin rounded-full border-4 border-gray-300 border-t-blue-500" />
            <p className="text-gray-600">Completing sign-in…</p>
          </>
        )}
      </div>
    </div>
  );
}

export default Callback;
